module.exports = __webpack_public_path__ + "static/media/A5.0e758700.jpg";